import * as React from "react";

import { Button, Divider, Grid, Segment, Tab } from "semantic-ui-react";

import { Detail } from "@neworbit/simpleui-detail";

import { isSystemAdminUser } from "@teamprevent/common/auth/roles";
import { getYesNoOptionEnabledDisplayValue } from "@teamprevent/common/model";

import DeleteButton from "../DeleteButton";
import { CoreDetailProps, DetailProps } from "../Detail";

import { BaseProps } from "../Base";

import { CoreDetailsButtons } from "./CoreDetailButtons";

import { Link } from "redux-little-router";

export const CoreDetails: React.FunctionComponent<CoreDetailProps & BaseProps> = (props) => {
    return (
        <Grid>
            <Detail label="Name" value={props.workGroup.name} labelWidth={5} valueWidth={11} />
            <Detail
                label="Medicals"
                value={props.workGroup.medicals && props.workGroup.medicals.map(
                    m => props.medicalTypeOptions.find(t => t.value === m)?.text ?? m).join(", ")}
                labelWidth={5}
                valueWidth={11}
            />
            <Detail
                label="Fast Track"
                value={getYesNoOptionEnabledDisplayValue(props.workGroup.isFastTrackPitPupSpecific || false)}
                labelWidth={5}
                valueWidth={11}
            />
        </Grid>
    );
};

const CoreDetailsWithActions: React.FunctionComponent<DetailProps & BaseProps> = (props) => {
    return (
        <div>
            <CoreDetails {...props} />
            <Divider />
            <Segment basic clearing vertical>
                {isSystemAdminUser(props.currentUser) &&
                    <DeleteButton />}
                <CoreDetailsButtons {...props} />
                {isSystemAdminUser(props.currentUser) &&
                    <Button icon="pencil" content="Edit" floated="right" as={Link} href={`${props.path}/edit`} />}
            </Segment>
        </div>
    );
};

export const coreDetailsTab = (props: DetailProps & BaseProps) => ({
    path: "",
    menuItem: "Details",
    render: () => <Tab.Pane><CoreDetailsWithActions {...props} /></Tab.Pane>
});
